module.exports = __webpack_public_path__ + "static/img/xsqk.240d455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/xsqk.png
// module id = ilYB
// module chunks = 41